import { BaseSdk } from '../../base.sdk';
import { ProspectCollectionDto } from '@zaplify/services/prospect-collections/shared';

export class ProspectCollectionsSdk extends BaseSdk {
    async getUserProspectCollections() {
        return await this.get<ProspectCollectionDto[]>(`${this.prospectCollectionsPath}`);
    }

    async getProspectCollectionById(prospectCollectionId: string) {
        return await this.get<ProspectCollectionDto>(`${this.prospectCollectionsPath}/${prospectCollectionId}`);
    }

    async createProspectCollection(
        dto: Partial<Omit<ProspectCollectionDto, 'id' | 'createdAt' | 'updatedAt' | 'isArchived'>>,
    ) {
        return await this.post<ProspectCollectionDto>({ path: this.prospectCollectionsPath, payload: dto });
    }

    async updateProspectCollection(
        prospectCollectionId: string,
        dto: Partial<Omit<ProspectCollectionDto, 'id' | 'createdAt' | 'updatedAt'>>,
    ) {
        return await this.put<ProspectCollectionDto>(`${this.prospectCollectionsPath}/${prospectCollectionId}`, dto);
    }
}
